import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import Middleware from "@/middleware/";
export const readiness = {

    path: "/",
    component: DashboardLayout,
    name: "Readinesss",
    children: [
        {
            path: "/readiness/create",
            name: "NewReadiness",
            component: () => import("@/modules/readiness/views/Readiness/New.vue"),
            meta: {
                groupName: "Readiness",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "readiness-create",
            },
        },
        {
            path: "/readiness/edit/:id",
            name: "EditReadiness",
            component: () => import("@/modules/readiness/views/Readiness/Edit.vue"),
            meta: {
                groupName: "Readiness",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "readiness-update",
            },
        },

        {
            path: "/readiness",
            name: "ReadinessPage",
            component: () => import("@/modules/readiness/views/Readiness/Show.vue"),
            meta: {
                groupName: "Readiness",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "readiness-index",
            },
        },

        {
            path: "/readiness/details/:id",
            name: "ReadinessDetailPage",
            component: () => import("@/modules/readiness/views/Readiness/Details.vue"),
            meta: {
                groupName: "Readiness",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "readiness-details",
            },
        },
    ],

}

export const readiness_damage = {

    path: "/",
    component: DashboardLayout,
    name: "DamageReadinessDamage",
    children: [
        {
            path: "/readiness-damage",
            name: "DamageReadinessDamagePage",
            component: () => import("@/modules/readiness/views/Damage/Show.vue"),
            meta: {
                groupName: "Readiness",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "readiness-damage-index",
            },
        },

    ]
}

export const readiness_street = {

    path: "/",
    component: DashboardLayout,
    name: "DamageReadinessStreetPage",
    children: [
        {
            path: "/readiness-street",
            name: "DamageReadinessStreet",
            component: () => import("@/modules/readiness/views/Street/Show.vue"),
            meta: {
                groupName: "Readiness",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "readiness-damage-index",
            },
        },

    ]
}